import PocketBase from 'pocketbase';

// IMPORTANT: Remplacez l'URL ci-dessous par l'URL de votre instance PocketBase
// Par exemple : https://votre-app.pockethost.io
const pb = new PocketBase('https://couleursirene.infocolab.online');

export default pb;
